module.exports = __webpack_public_path__ + "img/personal--data.9b60f149.svg";